import { render, staticRenderFns } from "./ServiceOS.vue?vue&type=template&id=0aacb9fd&scoped=true"
import script from "./ServiceOS.vue?vue&type=script&lang=ts"
export * from "./ServiceOS.vue?vue&type=script&lang=ts"
import style0 from "./ServiceOS.vue?vue&type=style&index=0&id=0aacb9fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aacb9fd",
  null
  
)

export default component.exports